import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import THEME from "../../../theme";
import { fs } from "../utils/styles";

const MONATSNAMEN = ["", "Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

export default function GewinnChart({ monatsentwicklung }) {
  const daten = monatsentwicklung.map(m => ({
    label: `${MONATSNAMEN[m.monat]} ${String(m.jahr).slice(2)}`,
    Gewinn: m.vorlaeufiges_betriebsergebnis, Einnahmen: m.einnahmen, Ausgaben: m.ausgaben,
  }));

  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Gewinnentwicklung (12 Monate)</h3>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={daten}>
          <CartesianGrid strokeDasharray="3 3" stroke={THEME.colors.border} />
          <XAxis dataKey="label" stroke={THEME.colors.textMuted} fontSize={12} />
          <YAxis stroke={THEME.colors.textMuted} fontSize={12} />
          <Tooltip contentStyle={{ background: THEME.colors.surface, border: `1px solid ${THEME.colors.border}`, color: THEME.colors.text }} />
          <Legend />
          <Line type="monotone" dataKey="Einnahmen" stroke={THEME.colors.success} strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="Ausgaben" stroke={THEME.colors.danger} strokeWidth={2} dot={false} />
          <Line type="monotone" dataKey="Gewinn" stroke={THEME.colors.primary} strokeWidth={3} dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
